<script>
import _ from "lodash";
import dayjs from "dayjs";
export default {
  computed: {
    dayjs() {
      return dayjs;
    },
    _() {
      return _;
    },
    age() {
      // let birth = parseInt(this.person.出生年月日) + 19110000 + "";
      // return dayjs().diff(birth.toString(), "year");

      let birth = parseInt(this.person.出生年月日) + 19110000 + "";
      let year = dayjs(birth).get("year");
      let thisYear = dayjs().get("year");
      return thisYear - year;
    },
    性別() {
      switch (this.person.身分證字號[1]) {
        case "1":
        case "A":
        case "C":
          return "男";
          break;
        case "2":
        case "B":
        case "D":
          return "女";
          break;
      }
    },
    isHospital() {
      return ["醫療院所"].includes(this.$store.state.user.角色);
    },
    isManager() {
      return ["管理者", "衛生局管理員", "衛生局", "衛生所管理者"].includes(
        this.$store.state.user.角色
      );
    },
    isAdmin() {
      return ["管理者", "衛生局管理員"].includes(this.$store.state.user.角色);
    },
    isOverTime() {
      return checkOverTime(this.$store.state.user.lastPasswordUpdated);
    },
    isOverTimeSoon() {
      return checkOverTime(this.$store.state.user.lastPasswordUpdated, 83);
    },
    checkOverTime() {
      return checkOverTime;
    },
  },
};

function checkOverTime(lastPasswordUpdated, expired = 90) {
  if (!lastPasswordUpdated) {
    return true;
  }
  if (dayjs().diff(lastPasswordUpdated, "day") > expired) {
    return true;
  }
  return false;
}
</script>

<style></style>
